<app-navsec></app-navsec>
<div #sectionSubscribe></div>
<div class="carrito">
    <div class="col-lg-12">
        <div class="row">
            <div class="col-lg-8 table-responsive">
                <table class="table mt-3">
                    <thead>
                        <tr>
                            <th scope="col">Producto</th>
                            <th scope="col"></th>
                            <th scope="col">Cantidad</th>
                            <th scope="col">Precio</th>
                            <th scope="col">Subtotal</th>
                            <th scope="col">Descuento</th>
                            <th scope="col">Total</th>
                            <th scope="col"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of compras;  let i = index">
                            <td><img [src]="item.imagenProd" class="img-fluid img-thumbnail" alt=" "> </td>
                            <td>
                                <h5>{{item.nombreprod}} <br></h5>
                            </td>
                            <td class="text-center">{{item.cantidad}}</td>
                            <td>${{item.precio | number}}</td>
                            <td>${{item.subtotal | number}}</td>
                            <td>{{item.descuento | number}}%</td>
                            <td>${{item.total | number}}</td>
                            <td>
                                <button class="btn btn-danger" title="Eliminar" (click)="borrarProducto(i)">
                            <i class="fa fa-trash"></i>
                        </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="col-lg-4 mt-3 ttal">
                <div class="col-lg-12">
                    <hr>
                    <h5>Datos de entrega:</h5>
                    <hr>
                    <form [formGroup]="deliveryForm" (ngSubmit)="infoUser(deliveryForm.value)">
                        <label for=""><b>Nombre completo:</b></label>
                        <small class="text-danger" *ngIf="nombreNoValido"> Ingrese su nombre</small>
                        <input type="text" class="form-control" placeholder="Ingrese su nombre" formControlName="nombre" [class.is-invalid]="nombreNoValido">

                        <label class="mt-2" for=""><b>Tipo documento:</b></label>
                        <small class="text-danger" *ngIf="tipodocumentoNoValido"> Seleccione el tipo de documento</small>
                        <select name="select" class="form-control" formControlName="tipodocumento" [class.is-invalid]="departamentoNoValido">
                          <option value="" selected>Seleccione tipo</option>
                          <option value="Cédula de Ciudadanía">Cédula de Ciudadanía</option>
                          <option value="Cédula de Extranjería">Cédula de Extranjería</option>
                          <option value="Tarjeta de Identidad">Tarjeta de Identidad</option>
                          <option value="Tarjeta de Extranjería">Tarjeta de Extranjería</option>
                          <option value="Permiso de Permanencia">Permiso de Permanencia</option>
                          <option value="NIT">NIT</option>
                          <option value="Otro">Otro</option>
                        </select>

                        <label class="mt-2" for=""><b>Número Identificación:</b></label>
                        <small class="text-danger" *ngIf="numeroNoValido"> Ingrese su número de identificación</small>
                        <input type="number" class="form-control" placeholder="Ingrese su número de identificación" formControlName="numero" [class.is-invalid]="numeroNoValido">

                        <label class="mt-2" for=""><b>Teléfono:</b></label>
                        <small class="text-danger" *ngIf="telefonoNoValido"> Ingrese su número de teléfono</small>
                        <input type="text" class="form-control" placeholder="Ingrese su número telefónico" formControlName="telefono" [class.is-invalid]="telefonoNoValido">


                        <label class="mt-2" for=""><b>Departamento:</b></label>
                        <small class="text-danger" *ngIf="departamentoNoValido"> Seleccione el departamento</small>
                        <select name="select" class="form-control" (change)="seleccionaDepartamento($event.target.value)" formControlName="departamento" [class.is-invalid]="departamentoNoValido">
                          <option value="" selected>Seleccione departamento</option>
                          <option *ngFor="let item of ciudadesList" [value]="item.nombre">{{item.nombre | titlecase}}</option>
                        </select>


                        <label class="mt-2 mb-2" for=""><b>Ciudad:</b></label>
                        <small class="text-danger" *ngIf="ciudadNoValido"> Seleccione la ciudad</small>
                        <select name="select" class="form-control" (change)="seleccionaCiudad($event.target.value)" formControlName="ciudad" [class.is-invalid]="ciudadNoValido">
                          <option value="" selected>Seleccione ciudad</option>
                          <option *ngFor="let item of citySelection" [value]="item">{{item | titlecase}}</option>
                        </select>


                        <label class="mt-2" for=""><b>Dirección:</b></label>
                        <small class="text-danger" *ngIf="direccionNoValido"> Ingrese la dirección de envío</small>
                        <input type="text" class="form-control" placeholder="Dirección de entrega" formControlName="direccion" [class.is-invalid]="direccionNoValido">


                        <button style="width: 100%;" class="btn btn-light btnPer mt-2" type="submit">
                            <i class="fa fa-user-plus" aria-hidden="true"> Confirmar datos </i>
                        </button>
                    </form>
                </div>
                <hr>
                <p>
                    <label for="Subtotal" class="blok"><b>Subtotal:</b></label>
                    <b class="liquid" style="float: right;">${{subtotal | number}}</b>
                </p>
                <p>
                    <label for="Subtotal" class="blok"><b>Descuento:</b></label>
                    <b class="liquid" style="float: right;">${{descuento | number}}</b>
                </p>
                <p *ngIf="precioFlete">
                  <label for="Subtotal" class="blok"><b>Flete:</b></label>
                  <b class="liquid" style="float: right;">${{precioFlete | number}}</b>
              </p>
                <p>
                    <label for="Subtotal" class="blok1"><b>TOTAL:</b></label>
                    <b class="liquid1" style="float: right;">${{lqd | number}}</b>
                </p>
                <div class="form-check">
                    <input class="form-check-input" type="checkbox" (change)="check($event.target.value)" id="defaultCheck1">
                    <label class="form-check-label" for="defaultCheck1">
                        Acepto términos y condiciones de Torreón Market y autorizo el tratamiento de mis datos personales con las siguientes condiciones. <a [routerLink]="['/terminos']">Ver términos de uso y políticas de privacidad</a>
                    </label>
                </div>
                <hr>                
                <div>
                  <h4><b>Por favor selecciona el medio de pago de tu preferencia:</b></h4>
                  <br>
                  <h5>PayU para pagar con otros medios de pago</h5>
                  <button class="btn btn-light" type="button" (click)="payu()">
                    <img src="../../../assets/img/logo_payu 2.png" width="150"  alt="">
                  </button>               
                </div>                
                <div>
                  <h5>Pagos QR Bancolombia o Daviplata</h5>
                  <button class="btn btn-light" type="button" (click)="bancolombia()" data-toggle="modal" data-target="#medioPago">
                    <img src="../../../assets/img/bancolombia.png" alt="" width="100">
                  </button>
                  <button class="btn btn-light ml-2" type="button" (click)="daviplata()" data-toggle="modal" data-target="#medioPago">
                    <img src="../../../assets/img/daviplata.png"  alt="" width="100">
                  </button>
                </div>
                <br>
            </div>
        </div>
    </div>
</div>
<app-footer></app-footer>

<div *ngIf="confirmado && checkOn" class="modal fade" id="medioPago" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
          <h4>Por favor abra su aplicación de <b>{{medio | titlecase}}</b> para escanear Qr.</h4>
          <h5>Recuerde ingresar el número de comprobante o referencia de pago y dar click en confirmar pago para que sea asignada correctamente</h5>
          <br>
          <div class="text-center" *ngIf="medio == 'bancolombia'">
              <img src="../../../assets/img/bancolombia.png" width="100" alt="">
              <br>
              <br>
              <img src="../../../assets/img/qrBancolombia.jpeg" width="250" alt="">
          </div>
          <div class="text-center" *ngIf="medio == 'daviplata'">
              <img src="../../../assets/img/daviplata.png" width="120" alt="">
              <br>
              <br>
              <img src="../../../assets/img/qrDaviplata.jpeg" width="250" alt="">
          </div>
          <br>
          <h5>{{numCertificacion}}:</h5>
          <input type="text" class="form-control certificar" placeholder="Ingrese comprobante" [(ngModel)]="comprobante">
          <br>
          <button class="btn btn-primary" (click)="compra()" data-dismiss="modal">Confirmar pago</button>
      </div>
    </div>
  </div>
</div>
